export default "https://storage.googleapis.com/prepweb-prod/dist/fdb9ac11a8441c39b6f67bb25aa88c4a.svg";